import React, { useEffect, useState } from "react";
import "./Appointment.css";
import { BackGroundAnimationColor, Calendar } from "../../components/index";
import roofing from "../../assets/images/roofing.png";
import sales_sign from "../../assets/images/sale-sign.png";
import Marketing from "../../assets/images/marketing.png";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Appointment = () => {
  const [isTablet, setIsTablet] = useState(false);
  const location = useLocation();
  const canonicalUrl = `https://doorclosers.me${location.pathname}`;
  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 884);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [currentSection, setCurrentSection] = useState(1);
  const [rotation, setRotation] = useState(0);

  const handleClick = (event) => {
    if (event.target.classList[0] !== "rebeat" && currentSection <= 7) {
      if (currentSection < 7) {
        document.getElementById(`section${currentSection}`).style.display =
          "none";
        const bulletId = `bullet${currentSection - 1}`;
        const bullet = document.getElementById(bulletId);
        if (bullet) bullet.style.display = "none";
        const numbertId = `number${currentSection}`;
        const number = document.getElementById(numbertId);
        if (number) {
          number.style.display = "block";
        }
        document.getElementById(`section${currentSection + 1}`).style.display =
          "flex";
        setCurrentSection((prev) => prev + 1);
        if (currentSection + 1 > 1) {
          const svg = document.querySelector(".rotating-svg");
          if (svg) svg.style.display = "block";
          setRotation((prev) => prev - 60);
          if (svg) {
            svg.style.transform = `rotate(${rotation}deg)`;
            svg.style.transition = "transform 1s";
          }
        }
      } else {
        const yCoordinate =
          document.getElementById("calendar").getBoundingClientRect().top +
          window.scrollY;
        const yOffset = window.innerWidth <= 884 ? -70 : -120;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
      }
    } else {
      for (let i = 1; i <= 6; i++) {
        const bulletId = `bullet${i}`;
        const bullet = document.getElementById(bulletId);
        if (bullet) {
          bullet.style.display = "block";
        }
        const numbertId = `number${i}`;
        const number = document.getElementById(numbertId);
        if (number) {
          number.style.display = "none";
        }
      }
      document.getElementById(`section${currentSection}`).style.display =
        "none";
      document.getElementById(`section1`).style.display = "block";
      const svg = document.querySelector(".rotating-svg");
      if (svg) svg.style.display = "none";
      setCurrentSection(1);
      setRotation(0);
    }
  };

  return (
    <>
      {!isTablet && <BackGroundAnimationColor />}
      <section
        onClick={handleClick}
        className="container d-flex flex-column align-items-center first-section-padding text-white app-container "
      >
        <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
        <div id="section1">
          <h1 className="responsive-text-60 section1-header">This Is Where</h1>
          <ul className="letter-list responsive-text-128 responsive-text-128-second">
            {"COLD MEETS HOT".split("").map((char, index) =>
              char === " " ? (
                <li key={index} className="letter-item">
                  &nbsp;
                </li>
              ) : (
                <li key={index} className="letter-item">
                  {char}
                </li>
              )
            )}
          </ul>
          <h1 className="responsive-text-36 section1-footer">Click To Start</h1>
        </div>

        <div id="section2" className="section">
          <h1 className="responsive-text-60 text-center mt-5 text-section s2-w1-animation">
            Your <span className="highlight">VA</span> Reaches Out To
            <br />
            Your Potential <span className="highlight">Prospects</span>
          </h1>
          <h1 className="section-continue ">Click To Continue</h1>
        </div>
        <div id="section3" className="section">
          <h1 className="responsive-text-60 text-center mt-5 text-section s2-w1-animation">
            An <span className="highlight">Appointment</span> Comes in
          </h1>
          <h1 className="section-continue">Click To Continue</h1>
        </div>
        <div id="section4" className="section">
          <h1 className="responsive-text-60 text-center mt-5 text-section s2-w1-animation">
            the <span className="highlight">Appointment</span> goes
            <br />
            to your <span className="highlight">CRM</span>
          </h1>
          <h1 className="section-continue">Click To Continue</h1>
        </div>
        <div id="section5" className="section">
          <h1 className="responsive-text-60 text-center mt-5 text-section s2-w1-animation">
            Your <span className="highlight">Pipeline</span> Grows
          </h1>

          <h1 className="section-continue">Click To Continue</h1>
        </div>
        <div id="section6" className="section">
          <h1 className="responsive-text-60 text-center mt-5 text-section s2-w1-animation">
            Your Team <span className="highlight">Expands</span>
            <br />
            With more <span className="highlight">sales</span>
          </h1>
          <h1 className="section-continue">Click To Continue</h1>
        </div>
        <div id="section7" className="section">
          <h1 className="text-center">
            <ul
              className="letter-list responsive-text-60 repeat-text"
              onClick={handleClick}
            >
              {"REPEAT".split("").map((char, index) => (
                <li key={index} className="rebeat letter-item">
                  {char}
                </li>
              ))}
            </ul>
          </h1>
          <h1 className="section-continue">Click To End</h1>
        </div>

        <div className="revolver">
          <svg
            className="rotating-svg svg"
            width="1141"
            height="1140"
            viewBox="0 0 1141 1140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="bullet1">
              <circle
                cx="570.124"
                cy="334.235"
                r="90.2897"
                fill="url(#paint1_linear_1365_1403)"
              />
              <path
                d="M547.002 312.95L546.985 302.454C546.982 301.003 547.62 299.893 548.899 299.123L560.535 291.808C562.496 290.61 564.159 290.01 565.524 290.007L575.764 289.991C577.556 289.988 578.454 290.882 578.457 292.674L578.583 369.602C578.584 370.626 578.372 371.352 577.946 371.779C577.605 372.121 576.966 372.293 576.027 372.294L565.019 372.312C563.227 372.315 562.33 371.421 562.327 369.629L562.224 307.293L549.692 314.481C547.901 315.252 547.005 314.742 547.002 312.95Z"
                fill="white"
              />
            </g>
            <g transform="rotate(60 772.01 446.286)" id="bullet2">
              <circle
                cx="772.01"
                cy="446.286"
                r="90.2897"
                fill="url(#paint2_linear_1365_1403)"
              />

              <path
                d="M745.94 487.366L746.025 476.102C746.07 470.129 748.668 465.242 753.817 461.441L779.177 442.432C783.554 439.137 785.763 434.887 785.802 429.682L785.84 424.69C785.902 416.498 781.88 412.372 773.773 412.31L764.558 412.241C756.537 412.18 752.495 416.245 752.433 424.437L752.389 430.197C752.381 431.221 751.908 431.729 750.97 431.722L747.258 431.694C746.319 431.687 745.854 431.171 745.861 430.147L745.906 424.26C745.948 418.713 747.602 414.374 750.869 411.241C754.135 408.108 758.542 406.563 764.088 406.605L774.456 406.683C780.003 406.725 784.342 408.337 787.476 411.518C790.695 414.615 792.283 418.979 792.241 424.611L792.2 429.987C792.15 436.642 789.421 441.998 784.014 446.053L758.394 465.443C754.79 468.147 752.972 471.504 752.942 475.514L752.886 482.938L790.773 483.225C791.711 483.232 792.177 483.705 792.17 484.644L792.147 487.716C792.139 488.654 791.667 489.12 790.728 489.113L747.465 488.785C746.441 488.778 745.933 488.304 745.94 487.366Z"
                fill="black"
              />
              <path
                d="M745.94 487.366L746.025 476.102C746.07 470.129 748.668 465.242 753.817 461.441L779.177 442.432C783.554 439.137 785.763 434.887 785.802 429.682L785.84 424.69C785.902 416.498 781.88 412.372 773.773 412.31L764.558 412.241C756.537 412.18 752.495 416.245 752.433 424.437L752.389 430.197C752.381 431.221 751.908 431.729 750.97 431.722L747.258 431.694C746.319 431.687 745.854 431.171 745.861 430.147L745.906 424.26C745.948 418.713 747.602 414.374 750.869 411.241C754.135 408.108 758.542 406.563 764.088 406.605L774.456 406.683C780.003 406.725 784.342 408.337 787.476 411.518C790.695 414.615 792.283 418.979 792.241 424.611L792.2 429.987C792.15 436.642 789.421 441.998 784.014 446.053L758.394 465.443C754.79 468.147 752.972 471.504 752.942 475.514L752.886 482.938L790.773 483.225C791.711 483.232 792.177 483.705 792.17 484.644L792.147 487.716C792.139 488.654 791.667 489.12 790.728 489.113L747.465 488.785C746.441 488.778 745.933 488.304 745.94 487.366Z"
                fill="white"
                stroke="white"
                strokeWidth="10"
                style={{ display: "none" }}
                id="number2"
              />
            </g>
            <g transform="rotate(120 762.745 675.947)" id="bullet3">
              <circle
                cx="762.745"
                cy="675.947"
                r="90.2897"
                fill="url(#paint5_linear_1365_1403)"
              />
              <path
                d="M767.502 675.17L775.182 675.211C783.288 675.255 787.363 671.223 787.407 663.116L787.449 655.181C787.493 646.989 783.462 642.871 775.355 642.828L765.499 642.775C757.393 642.731 753.317 646.806 753.274 654.998L753.249 659.606C753.244 660.544 752.815 661.011 751.961 661.007L748.249 660.987C747.311 660.982 746.844 660.51 746.849 659.571L746.874 654.835C746.904 649.289 748.549 644.946 751.808 641.806C755.068 638.666 759.471 637.111 765.017 637.14L775.897 637.198C781.444 637.228 785.83 638.83 789.056 642.005C792.281 645.18 793.879 649.54 793.85 655.087L793.806 663.279C793.764 671.129 790.196 676.06 783.103 678.07C790.175 680.07 793.689 685.081 793.646 693.102L793.6 701.806C793.57 707.353 791.925 711.696 788.666 714.836C785.406 717.976 781.003 719.531 775.457 719.501L764.577 719.443C759.03 719.413 754.644 717.811 751.418 714.637C748.193 711.462 746.595 707.101 746.624 701.555L746.655 695.795C746.661 694.771 747.133 694.261 748.071 694.266L751.783 694.286C752.637 694.291 753.061 694.805 753.055 695.829L753.025 701.461C752.981 709.653 757.012 713.77 765.119 713.814L774.975 713.867C783.081 713.91 787.157 709.836 787.2 701.644L787.246 693.196C787.29 685.004 783.258 680.886 775.152 680.843L767.472 680.802C766.533 680.797 766.066 680.325 766.071 679.386L766.086 676.571C766.091 675.632 766.563 675.165 767.502 675.17Z"
                fill="black"
              />
              <path
                d="M767.502 675.17L775.182 675.211C783.288 675.255 787.363 671.223 787.407 663.116L787.449 655.181C787.493 646.989 783.462 642.871 775.355 642.828L765.499 642.775C757.393 642.731 753.317 646.806 753.274 654.998L753.249 659.606C753.244 660.544 752.815 661.011 751.961 661.007L748.249 660.987C747.311 660.982 746.844 660.51 746.849 659.571L746.874 654.835C746.904 649.289 748.549 644.946 751.808 641.806C755.068 638.666 759.471 637.111 765.017 637.14L775.897 637.198C781.444 637.228 785.83 638.83 789.056 642.005C792.281 645.18 793.879 649.54 793.85 655.087L793.806 663.279C793.764 671.129 790.196 676.06 783.103 678.07C790.175 680.07 793.689 685.081 793.646 693.102L793.6 701.806C793.57 707.353 791.925 711.696 788.666 714.836C785.406 717.976 781.003 719.531 775.457 719.501L764.577 719.443C759.03 719.413 754.644 717.811 751.418 714.637C748.193 711.462 746.595 707.101 746.624 701.555L746.655 695.795C746.661 694.771 747.133 694.261 748.071 694.266L751.783 694.286C752.637 694.291 753.061 694.805 753.055 695.829L753.025 701.461C752.981 709.653 757.012 713.77 765.119 713.814L774.975 713.867C783.081 713.91 787.157 709.836 787.2 701.644L787.246 693.196C787.29 685.004 783.258 680.886 775.152 680.843L767.472 680.802C766.533 680.797 766.066 680.325 766.071 679.386L766.086 676.571C766.091 675.632 766.563 675.165 767.502 675.17Z"
                fill="white"
                stroke="white"
                strokeWidth="10"
                style={{ display: "none" }}
                id="number3"
              />
            </g>
            <g transform="rotate(180 573.831 802.815)" id="bullet4">
              <circle
                cx="573.831"
                cy="802.815"
                r="90.2897"
                fill="url(#paint0_linear_1365_1403)"
              />

              <path
                d="M584.416 818.328L584.708 763.673L552.16 818.155L584.416 818.328ZM589.159 840.882L585.703 840.863C584.764 840.858 584.298 840.344 584.303 839.32L584.385 824.088L547.265 823.889C545.985 823.882 545.348 823.282 545.355 822.087L545.367 819.783C545.371 819.015 545.675 818.035 546.279 816.844L580.117 760.448C580.892 759.172 581.919 758.538 583.199 758.545L589.215 758.577C590.41 758.583 591.004 759.226 590.997 760.506L590.687 818.362L600.287 818.413C601.226 818.418 601.693 818.847 601.688 819.701L601.672 822.772C601.667 823.711 601.195 824.178 600.256 824.173L590.657 824.122L590.575 839.353C590.57 840.377 590.098 840.887 589.159 840.882Z"
                fill="black"
              />
              <path
                d="M584.416 818.328L584.708 763.673L552.16 818.155L584.416 818.328ZM589.159 840.882L585.703 840.863C584.764 840.858 584.298 840.344 584.303 839.32L584.385 824.088L547.265 823.889C545.985 823.882 545.348 823.282 545.355 822.087L545.367 819.783C545.371 819.015 545.675 818.035 546.279 816.844L580.117 760.448C580.892 759.172 581.919 758.538 583.199 758.545L589.215 758.577C590.41 758.583 591.004 759.226 590.997 760.506L590.687 818.362L600.287 818.413C601.226 818.418 601.693 818.847 601.688 819.701L601.672 822.772C601.667 823.711 601.195 824.178 600.256 824.173L590.657 824.122L590.575 839.353C590.57 840.377 590.098 840.887 589.159 840.882Z"
                fill="white"
                stroke="white"
                strokeWidth="10"
                style={{ display: "none" }}
                id="number4"
              />
            </g>
            <g transform="rotate(240 370.104 687.059)" id="bullet5">
              <circle
                cx="370.104"
                cy="687.059"
                r="90.2897"
                fill="url(#paint4_linear_1365_1403)"
              />
              <path
                d="M373.576 673.16L362.568 673.101C360.52 673.09 358.812 673.422 357.443 674.097C356.074 674.773 355.174 675.536 354.743 676.387C353.622 678.514 352.592 679.576 351.654 679.571L347.558 679.549C346.704 679.544 346.28 679.072 346.285 678.134L346.497 638.582C346.502 637.558 346.932 637.049 347.785 637.053L389.384 637.276C390.408 637.281 390.918 637.753 390.913 638.692L390.896 641.892C390.891 642.831 390.376 643.297 389.352 643.292L352.873 643.097L352.708 673.816C354.267 669.643 357.947 667.572 363.75 667.603L374.502 667.661C380.048 667.69 384.392 669.25 387.533 672.338C390.674 675.427 392.229 679.788 392.199 685.42L392.113 701.419C392.083 707.051 390.438 711.48 387.178 714.705C383.918 717.93 379.515 719.528 373.968 719.499L363.728 719.444C358.182 719.414 353.796 717.769 350.571 714.509C347.431 711.25 345.876 706.804 345.906 701.172L345.93 696.692C345.935 695.668 346.365 695.158 347.218 695.163L350.93 695.183C351.869 695.188 352.335 695.702 352.33 696.726L352.306 701.078C352.285 705.089 353.292 708.209 355.328 710.439C357.364 712.668 360.345 713.794 364.27 713.815L373.486 713.864C377.412 713.885 380.404 712.834 382.463 710.712C384.609 708.505 385.692 705.353 385.714 701.257L385.796 685.897C385.841 677.449 381.768 673.204 373.576 673.16Z"
                fill="black"
              />
              <path
                d="M373.576 673.16L362.568 673.101C360.52 673.09 358.812 673.422 357.443 674.097C356.074 674.773 355.174 675.536 354.743 676.387C353.622 678.514 352.592 679.576 351.654 679.571L347.558 679.549C346.704 679.544 346.28 679.072 346.285 678.134L346.497 638.582C346.502 637.558 346.932 637.049 347.785 637.053L389.384 637.276C390.408 637.281 390.918 637.753 390.913 638.692L390.896 641.892C390.891 642.831 390.376 643.297 389.352 643.292L352.873 643.097L352.708 673.816C354.267 669.643 357.947 667.572 363.75 667.603L374.502 667.661C380.048 667.69 384.392 669.25 387.533 672.338C390.674 675.427 392.229 679.788 392.199 685.42L392.113 701.419C392.083 707.051 390.438 711.48 387.178 714.705C383.918 717.93 379.515 719.528 373.968 719.499L363.728 719.444C358.182 719.414 353.796 717.769 350.571 714.509C347.431 711.25 345.876 706.804 345.906 701.172L345.93 696.692C345.935 695.668 346.365 695.158 347.218 695.163L350.93 695.183C351.869 695.188 352.335 695.702 352.33 696.726L352.306 701.078C352.285 705.089 353.292 708.209 355.328 710.439C357.364 712.668 360.345 713.794 364.27 713.815L373.486 713.864C377.412 713.885 380.404 712.834 382.463 710.712C384.609 708.505 385.692 705.353 385.714 701.257L385.796 685.897C385.841 677.449 381.768 673.204 373.576 673.16Z"
                fill="white"
                stroke="white"
                strokeWidth="10"
                style={{ display: "none" }}
                id="number5"
              />
            </g>
            <g transform="rotate(300 368.25 455.547)" id="bullet6">
              <circle
                cx="368.25"
                cy="455.547"
                r="90.2897"
                fill="url(#paint3_linear_1365_1403)"
              />
              <path
                d="M362.573 483.096L373.453 483.154C377.379 483.175 380.371 482.125 382.43 480.002C384.49 477.795 385.531 474.643 385.553 470.547L385.619 458.259C385.64 454.248 384.633 451.171 382.596 449.027C380.56 446.797 377.579 445.672 373.654 445.651L350.742 445.528L350.609 470.36C350.588 474.456 351.595 477.619 353.631 479.848C355.667 481.992 358.648 483.075 362.573 483.096ZM373.934 488.917L362.031 488.853C356.484 488.824 352.098 487.179 348.873 483.919C345.648 480.659 344.05 476.213 344.08 470.581L344.326 424.63C344.356 418.998 346.001 414.569 349.261 411.344C352.521 408.118 356.925 406.521 362.471 406.55L386.791 406.681C387.729 406.686 388.196 407.157 388.191 408.096L388.175 411.168C388.17 412.021 387.699 412.445 386.76 412.44L362.952 412.313C359.027 412.292 356.034 413.385 353.975 415.593C351.915 417.715 350.875 420.825 350.853 424.92L350.773 439.768L374.197 439.894C379.743 439.923 384.129 441.568 387.355 444.828C390.58 448.088 392.178 452.491 392.148 458.038L392.079 470.838C392.049 476.47 390.404 480.898 387.144 484.124C383.884 487.349 379.481 488.947 373.934 488.917Z"
                fill="black"
              />
              <path
                d="M362.573 483.096L373.453 483.154C377.379 483.175 380.371 482.125 382.43 480.002C384.49 477.795 385.531 474.643 385.553 470.547L385.619 458.259C385.64 454.248 384.633 451.171 382.596 449.027C380.56 446.797 377.579 445.672 373.654 445.651L350.742 445.528L350.609 470.36C350.588 474.456 351.595 477.619 353.631 479.848C355.667 481.992 358.648 483.075 362.573 483.096ZM373.934 488.917L362.031 488.853C356.484 488.824 352.098 487.179 348.873 483.919C345.648 480.659 344.05 476.213 344.08 470.581L344.326 424.63C344.356 418.998 346.001 414.569 349.261 411.344C352.521 408.118 356.925 406.521 362.471 406.55L386.791 406.681C387.729 406.686 388.196 407.157 388.191 408.096L388.175 411.168C388.17 412.021 387.699 412.445 386.76 412.44L362.952 412.313C359.027 412.292 356.034 413.385 353.975 415.593C351.915 417.715 350.875 420.825 350.853 424.92L350.773 439.768L374.197 439.894C379.743 439.923 384.129 441.568 387.355 444.828C390.58 448.088 392.178 452.491 392.148 458.038L392.079 470.838C392.049 476.47 390.404 480.898 387.144 484.124C383.884 487.349 379.481 488.947 373.934 488.917Z"
                fill="white"
                stroke="white"
                strokeWidth="10"
                style={{ display: "none" }}
                id="number6"
              />
            </g>
            <path
              d="M166.678 679.985C171.332 675.873 157.037 662.002 160.21 658.505C142.566 615.793 157.344 637.922 147.589 588.65C141.539 558.095 154.05 510.072 160.983 486.255C160.752 475.559 162.706 472.306 163.601 468.369C167.307 452.191 172.841 436.618 178.151 420.948C183.633 404.82 191.149 389.521 198.658 374.386C207.003 357.554 217.921 342.076 228.646 326.546C240.811 308.935 254.507 292.706 268.959 277.011C273.054 272.559 277.41 264.777 289.055 254.004C329.37 216.707 328.568 216.125 352.998 202.977C359.139 199.672 379.781 186.596 404.669 177.319C419.1 170.346 463.876 158.824 469.351 157.274C520.745 142.726 586.932 144.924 651.492 156.655C670.743 160.14 718.208 176.919 734.835 185.316C748.193 189.447 761.285 196.981 770.189 204.374C778.145 210.981 860.015 263.696 866.65 270.397C913.276 317.425 947.412 372.012 968.823 434.632C969.779 437.44 971.485 440.001 972.474 442.8C975.291 450.723 977.364 457.681 979.934 471.6C980.046 485.383 988.566 540.087 981.611 557.113C983.693 569.213 984.512 587.905 982.569 598.783C984.436 610.38 980.882 642.634 979.635 654.747C978.577 658.17 979.735 664.961 978.873 668.889C974.94 686.714 969.105 703.921 962.648 720.948C954.563 742.334 944.207 762.619 932.746 782.397C919.484 805.301 903.688 826.236 886.157 845.953C884.957 847.307 883.705 848.605 882.684 850.087C878.911 855.551 874.171 860.114 868.978 864.147C862.235 869.366 855.313 872.406 849.42 879.334C837.866 886.385 812.68 909.219 790.305 922.056C775.264 938.06 709.578 959.828 697.058 965.956C692.007 968.144 681.943 976.147 669.826 978.171C639.964 983.154 610.13 988.485 579.759 988.913C543.768 989.419 508.128 986.267 473.255 976.722C470.128 975.863 466.818 975.678 463.639 975.012C460.406 974.344 449.001 973.669 448.246 970.252C427.89 963.962 402.048 949.101 362.093 931.864C335.74 913.041 315.741 899.868 287.902 876.107C279.183 868.668 284.152 870.044 277.261 867.913C262.761 863.429 214.95 795.015 193.295 751.864C182.536 730.437 174.069 707.989 167.727 684.814C167.208 682.86 165.846 680.879 166.657 679.973L166.678 679.985ZM421.313 601.103C371.918 572.3 309.337 591.209 283.775 638.525C254.246 693.194 271.861 746.513 320.218 776.678C368.1 806.549 430.593 786.954 458.214 742.063C488.211 693.313 468.283 624.559 421.313 601.103ZM809.242 585.312C759.417 557.129 695.955 579.206 672.445 626.475C646.931 677.729 658.499 732.636 713.978 763.81C761.177 790.333 823.076 776.423 853.187 718.724C874.759 677.361 863.348 613.03 809.242 585.312ZM656.156 386.795C686.057 333.249 668.034 275.542 622.262 248.401C569.637 217.185 510.168 235.141 481.617 284.282C451.633 335.841 469.471 392.585 518.574 422.805C567.846 453.12 632.849 431.017 656.156 386.795ZM419.022 367.408C370.965 339.491 308.086 355.404 280.91 405.314C253.119 456.322 267.871 513.228 319.027 543.597C367.215 572.225 429.675 554.081 456.938 505.607C484.803 456.054 467.036 392.972 419.013 367.375L419.022 367.408ZM820.618 358.694C769.265 331.46 711.599 348.871 683.572 397.917C654.71 448.41 671.927 508.107 722.983 536.867C749.7 551.924 778.502 554.752 807.628 543.535C838.807 531.523 859.292 509.297 869.045 477.223C880.634 439.13 871.259 388.693 820.618 358.694ZM623.329 713.884C573.908 686.37 512.523 703.783 486.025 751.881C457.238 804.079 473.107 860.722 523.195 890.023C575.447 920.616 632.865 899.129 660.956 853.89C691.165 805.258 671.683 739.582 623.362 713.875L623.329 713.884ZM647.914 609.588C662.141 590.273 661.092 567.308 655.341 545.212C649.452 522.567 635.819 504.499 614.199 492.786C571.126 469.455 519.311 484.337 495.339 526.274C473.356 564.746 484.928 620.737 529.626 645.281C569.732 667.316 626.858 652.96 647.935 609.6L647.914 609.588Z"
              fill="url(#paint6_linear_1365_1403)"
            />
            <circle
              cx="565.35"
              cy="562.822"
              r="418.78"
              stroke="url(#paint7_linear_1365_1403)"
              strokeWidth="32"
            />
            <path
              d="M491.018 552.922C481.694 596.808 509.694 639.939 553.558 649.259C597.422 658.578 640.539 630.556 649.863 586.671C659.187 542.785 631.187 499.653 587.324 490.334C543.46 481.014 500.343 509.036 491.018 552.922Z"
              fill="url(#paint8_angular_1365_1403)"
              fillOpacity="0.25"
            />

            <defs>
              <linearGradient
                id="paint0_linear_1365_1403"
                x1="573.831"
                y1="712.525"
                x2="573.831"
                y2="893.105"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.15" stopColor="#603C00" />
                <stop offset="0.435" stopColor="#FF9F00" />
                <stop offset="1" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_1365_1403"
                x1="570.124"
                y1="243.945"
                x2="570.124"
                y2="424.525"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.15" stopColor="#603C00" />
                <stop offset="0.435" stopColor="#FF9F00" />
                <stop offset="1" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_1365_1403"
                x1="772.01"
                y1="355.997"
                x2="772.01"
                y2="536.576"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.15" stopColor="#603C00" />
                <stop offset="0.435" stopColor="#FF9F00" />
                <stop offset="1" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_1365_1403"
                x1="368.25"
                y1="365.258"
                x2="368.25"
                y2="545.837"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.15" stopColor="#603C00" />
                <stop offset="0.435" stopColor="#FF9F00" />
                <stop offset="1" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_1365_1403"
                x1="370.104"
                y1="596.769"
                x2="370.104"
                y2="777.349"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.15" stopColor="#603C00" />
                <stop offset="0.435" stopColor="#FF9F00" />
                <stop offset="1" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_1365_1403"
                x1="762.745"
                y1="585.657"
                x2="762.745"
                y2="766.237"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.15" stopColor="#603C00" />
                <stop offset="0.435" stopColor="#FF9F00" />
                <stop offset="1" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_1365_1403"
                x1="903.256"
                y1="873.981"
                x2="169.712"
                y2="464.36"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#939493" />
                <stop offset="0.205" stopColor="#6A6B6A" />
                <stop offset="0.545" stopColor="#2E2E2E" />
                <stop offset="0.82" stopColor="#454545" />
                <stop offset="0.935" stopColor="#7D7D7D" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_1365_1403"
                x1="565.35"
                y1="128.043"
                x2="565.35"
                y2="997.602"
                gradientUnits="userSpaceOnUse"
              >
                <stop />
                <stop offset="1" stopColor="#666666" />
              </linearGradient>
              <radialGradient
                id="paint8_angular_1365_1403"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(570.441 569.796) rotate(101.995) scale(81.2362 81.1952)"
              >
                <stop offset="0.185" stopColor="#919191" />
                <stop offset="0.53" />
                <stop offset="1" stopColor="#666666" />
              </radialGradient>
            </defs>
          </svg>
        </div>
      </section>
      <h1
        className="responsive-text-60 highlight text-center mt-5 mb-5"
        id="outreach"
      >
        We Helped Clients Optimize
        <br />
        Their Outreach
        <br />
        In Various Niches As
      </h1>
      <div className="outreach-container" id="solar">
        <h1 className="responsive-text-60 text-white">ROOFING</h1>
        <img src={roofing} alt="Roofing" className="roofing-part roofing6" />

        <h1 className="responsive-text-60 text-white text-end">SOLAR</h1>
        <br />
        <h1
          className="responsive-text-60 text-white text-start"
          id="realestate"
        >
          REALTORS
        </h1>
        <img src={sales_sign} alt="Sale Sign" className="rotate-image" />

        <h1 className="responsive-text-60 text-white text-end" id="marketing">
          MARKETING
          <br />
          AGENCIES
        </h1>
        <img src={Marketing} alt="Marketing" className="zoom-image" />
      </div>

      <div className="toggle" id="calendar">
        <h1 className="sentence responsive-text-128 highlight text-center new-to-game ">
          NEW TO THE GAME?
        </h1>
        <h1 className="sentence responsive-text-128 highlight text-center ">
          ALREADY THERE?
        </h1>
        <h1 className="sentence responsive-text-128 highlight text-center text-white">
          READY TO EXPAND?
        </h1>
      </div>
      <Calendar />
    </>
  );
};

export default Appointment;
